import { image, selectedImage } from './mapIcons';
import { contentString } from '../utilities';
import { createCustomMarkerElement } from '../createCustomMarkerElement';

// CHANGED: Function must be ASYNC to await the library import
export default async function addProjects({ project, projects, map }, pins, onClick, showProjects = true) {

  // 1. Import the library
  const { AdvancedMarkerElement } = await window.google.maps.importLibrary("marker");

  // 2. Cleanup old pins
  for (let i in pins) {
    if (pins[i]) {
      // Advanced Markers use direct property assignment to remove
      pins[i].map = null;
    }
  }

  if (!showProjects) {
    return {};
  }

  const pp = {};

  for (let i in projects) {
    const { id, site = {} } = projects[i];
    const { siteRepEmail: email, siteRepName: contact, siteRepPhone: phone, geocode_results } = site;

    // Safety Check: Prevent crash if data is missing
    if (!geocode_results || !geocode_results.geometry || !geocode_results.geometry.location) {
      continue; 
    }
    
    // Ensure lat/lng are strictly numbers
    const lat = Number(geocode_results.geometry.location.lat);
    const lng = Number(geocode_results.geometry.location.lng);

    if (isNaN(lat) || isNaN(lng)) {
        continue;
    }
    
    const cleanPosition = { lat, lng };
    const { formatted_address: title } = geocode_results;

    // Determine which icon to use
    let iconData = id === project.id ? selectedImage() : image();

    console.log('project.id',project.id)

    try {
        // 3. Create the Advanced Marker
        const marker = new AdvancedMarkerElement({
              position: cleanPosition, 
              map,
              title,
              // Use 'content' instead of 'icon', and ensure it is a DOM element
              content: createCustomMarkerElement(iconData),
        });

        const content = contentString({ name: title, contact, phone, email });
        const infoWindow = new window.google.maps.InfoWindow({ content });

        marker.addListener('click', () => {
          onClick(projects[i]);
          // 4. Updated InfoWindow syntax
          infoWindow.open({
            anchor: marker,
            map,
          });
        });

        pp[id] = marker;

    } catch (error) {
        console.error('Error adding marker for project ID:', id, error);
    }   
  }

  return pp;
}